const updatePageTitle = (newTitle) => {
  document.title = `${newTitle} | Zakotane Railway`;
};

export default updatePageTitle;
